module.exports = __webpack_public_path__ + "static/media/shinshin-logo.e8d0faed.png";